import React from 'react';
import {Box} from "@mui/material";
import {Bar} from "react-chartjs-2";

const HeatBar = ({ label, score, rating, chartRef, reverse }) => {
    const chartData = {
        labels: [`${label}`],
        datasets: [
            {
                label: `${label} Score`,
                data: [100],
                backgroundColor: function (context) {
                    const chart = context.chart;
                    const {ctx, chartArea} = chart;
                    if (!chartArea) return 'gray';

                    const gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
                    if (reverse) {
                        gradient.addColorStop(0, 'red');
                        gradient.addColorStop(0.5, 'yellow');
                        gradient.addColorStop(1, 'green');
                    } else {
                        gradient.addColorStop(0, 'green');
                        gradient.addColorStop(0.5, 'yellow');
                        gradient.addColorStop(1, 'red');
                    }
                    return gradient;
                },
                borderRadius: 5,
                barThickness: 30,
            },
        ],
    };

    const chartOptions = {
        indexAxis: 'y',
        scales: {
            x: {
                min: 0,
                max: 100,
                ticks: {color: '#f0f0f0', stepSize: 20},
            },
            y: {
                ticks: {display: false},
            },
        },
        plugins: {
            legend: {display: false},
            // tooltip: { enabled: false }
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    const markerPlugin = {
        id: 'markerLine',
        afterDatasetsDraw: (chart) => {
            if (!score) return;
            const {ctx, chartArea: {top, bottom}, scales: {x}} = chart;
            const resilienceX = x.getPixelForValue(score);

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(resilienceX, top);
            ctx.lineTo(resilienceX, bottom);
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 4;
            ctx.stroke();

            ctx.fillStyle = 'black';
            ctx.font = '12px sans-serif';
            ctx.fillText(`${rating}`, resilienceX + 4, top + 12);
            ctx.restore();
        },
    };

    return (
        <Box className="chart-container">
            <Bar
                ref={chartRef}
                data={chartData}
                options={chartOptions}
                plugins={[markerPlugin]}
            />
        </Box>
    )
};

export default HeatBar;